import { ArrayType } from "@angular/compiler/src/output/output_ast";

export class EmailAddressModel {
  public email: string;
}

export class UserProfileAddressModel {
  public houseNo: string;
  public houseExtention: string;
  public street: string;
  public city: string;
  public zipCode: string;
  public address: string;
  public latitiude: number;
  public logitude: number;
}

export class CreditCardDetails {
  public creditCardNumber: string;
  public creditCardExpirationDate: Date;
  public creditCardHashId: string;
}

export class UserProfileModel {
  public personMasterHashId: string;
  public userName: string;
  public firstName: string;
  public lastName: string;
  public middleName: string;
  public countryCode1: string = "";
  public countryCode2: string = "";
  public telephone1: string;
  public telephone2: string;
  public isActive: boolean;
  public personHomeAddressModel: UserProfileAddressModel;
  public personWorkAddressModel: UserProfileAddressModel;
  public CreditCardDetails: Array<CreditCardDetails>;
  public emailAddressModel: EmailAddressModel;
  public personPassword: string;
  public personConfirmPassword: string;
  public validateLiceanceNumber: boolean = false;
  public dateOfBirth: string;
  public driverLicenceNumber: string;
  public liceanceNumberValidated: boolean;
  public nifNumber: string;
  public isnifEnabled: boolean = false;
  public countryCodeHashId:string;
  public sso:boolean = false;
  
  constructor() {
    this.personHomeAddressModel = new UserProfileAddressModel();
    this.personWorkAddressModel = new UserProfileAddressModel();
    this.emailAddressModel = new EmailAddressModel();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/userprofile/models/userprofile.model.ts